<template>
  <v-menu
    ref="credit_date_from"
    v-model="dateFrom"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dateFromTemplate"
        :label="label"
        prepend-icon="event"
        v-on="on"
        v-on:blur="formatDateFrom"
        v-mask="'##.##.####'"
        return-masked-value
        :rules="rules.rule"
        required
        :disabled="disabled"
      ></v-text-field>
    </template>

    <v-date-picker
      ref="picker"
      v-model="dateFromModelPicker"
      @change="saveCreditDateFrom"
      llocale="ru-ru"
      first-day-of-week="1"
      no-title
    ></v-date-picker>
  </v-menu>
</template>

<script>
import rules from "@/utils/data/rules";
import { mask } from "vue-the-mask";
export default {
  name: "Calendar",
  directives: { mask },
  props: {
    label: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    date: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    dateFrom: null,
    dateFromTemplate: null,
    dateFromModelPicker: null,
    rules,
  }),
  model: {
    prop: "date",
    event: "change",
  },
  computed: {},
  mounted() {
    console.log("MOUNTED THIS DATE", this.date);
    if (this.date && this.date.split("-").length > 0) {
     //  this.dateFromTemplate = this.date;
      this.dateFromTemplate = this.date
        .split("-")
        .reverse()
        .join(".");
      this.formatDateFrom();
    }
  },
  methods: {
    formatDateFrom() {
      if (this.dateFromTemplate) {
        this.dateFromModelPicker = this.dateFromTemplate
          .split(".")
          .reverse()
          .join("-");
      }
    },
    saveCreditDateFrom(date) {
      this.$refs.credit_date_from.save(date);
      this.deFormatDateFrom();
    },
    deFormatDateFrom() {
      if (this.dateFromModelPicker) {
        const clearDate = this.dateFromModelPicker.substr(0, 10);

        this.dateFromTemplate = clearDate
          .split("-")
          .reverse()
          .join(".");
      }
    },
  },
  watch: {
    dateFromTemplate(val) {
      this.$emit(
        "change",
        val
          ? val
              .split(".")
              .reverse()
              .join("-")
          : null
      );
    },
    // search(val) {
    //   console.log("SEARRCH", val);
    //   // if (this.isLoading) return;
    //   if (this.model) {
    //     let paramValue = this.isInn ? "inn" : "value";
    //     if (this.model[paramValue] != val) this.model = null;
    //   }
    //   this.getCompanyAPI(val);
    // },
  },
};
</script>
